<template>
  <div
    class="oficina-sidebar"
    :class="{ collapsed: collapsed, open: mobileOpen }"
    id="oficina-sidebar"
  >
    <div class="oficina-sidebar-header">
      <button
        v-if="shouldShowCloseButton"
        type="button"
        class="oficina-sidebar-close-btn"
        id="btn-close-sidebar"
        aria-label="Fechar menu"
        @click="$emit('close-mobile')"
      >
        <i class="icofont-close"></i>
      </button>
      <button
        type="button"
        class="oficina-sidebar-toggle-btn"
        id="btn-toggle-sidebar"
        aria-label="Esconder/Mostrar menu"
        @click="$emit('toggle')"
      >
        <span id="sidebar-toggle-icon" class="oficina-chevron" aria-hidden="true"></span>
      </button>
      <h2>Guia de Oficina de M & A</h2>
      <div class="oficina-sidebar-info">
        <p>
          <span class="oficina-icon-user"></span>
          <span id="sidebar-facilitator-name">{{ config.facilitatorName || 'Facilitador' }}</span>
        </p>
        <p>
          <span class="oficina-icon-monitor"></span>
          Via: <span id="sidebar-platform">{{ config.platform }}</span>
        </p>
        <p
          v-if="!isPresencial"
          id="sidebar-contact-info"
        >
          <span class="oficina-icon-users"></span>
          Ref: <span id="sidebar-contact-name">{{ config.contactName || 'Ponto Focal' }}</span>
        </p>
      </div>
    </div>
    <div class="oficina-sidebar-steps" id="sidebar-steps">
      <button
        v-for="(step, idx) in steps"
        :key="idx"
        type="button"
        class="oficina-step-item"
        :class="{ active: idx === currentStepIndex }"
        @click="$emit('step-selected', idx)"
      >
        <span class="oficina-step-number">{{ idx + 1 }}.</span> {{ step.title }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    config: {
      type: Object,
      required: true,
    },
    currentStepIndex: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    mobileOpen: {
      type: Boolean,
      default: false,
    },
    isPresentationMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPresencial() {
      return this.config.platform === 'Presencial'
    },
    shouldShowCloseButton() {
      // Garantir que o botão só apareça quando NÃO estiver em modo apresentação
      return !this.isPresentationMode
    },
  },
  watch: {
    isPresentationMode: {
      immediate: true,
      handler(newVal) {
        // Forçar atualização quando o modo mudar
        this.$forceUpdate()
      }
    }
  },
  emits: ['toggle', 'close-mobile', 'step-selected', 'go-to-settings'],
}
</script>

<style scoped>
/* Estilos serão adicionados em arquivo CSS separado */
</style>
